<img [src]="selectedVersion?.image" width="100%" />
<div class="details">
  <div>
    <h3>
      <img height="24" width="24" [src]="page?.product?.thumbnail" />
      {{ page?.product?.name }} · {{ page?.name }}
    </h3>
    <hr />
    <!-- actions -->
    <div>
      <a
        [href]="page?.url"
        target="_blank"
        (click)="sharedService.logEvent('visit_page_clicked')"
      >
        <kor-menu-item
          icon="link"
          label="visit page"
          [toggle]="false"
        ></kor-menu-item>
      </a>
      <kor-menu-item
        icon="favorite"
        label="add to collection"
        [toggle]="false"
        (click)="
          sharedService.logEvent('add_to_collection_clicked');
          addToCollectionModalVisible = true
        "
      ></kor-menu-item>
    </div>
  </div>
  <!-- versions -->
  <div>
    <h3>versions</h3>
    <hr />
    <div>
      <kor-menu-item
        *ngFor="let version of versions"
        [active]="selectedVersion.uid === version.uid"
        [routerLink]="['./', { version: version.uid }]"
        [label]="version.date.toDate() | date"
        icon="schedule"
        [toggle]="false"
        (click)="sharedService.logEvent('version_clicked')"
      ></kor-menu-item>
    </div>
  </div>
  <!-- patterns -->
  <div>
    <h3>patterns</h3>
    <hr />
    <div class="tags">
      <kor-tag *ngFor="let tag of tags?.patterns" [label]="tag"></kor-tag>
    </div>
  </div>
  <!-- elements -->
  <div>
    <h3>elements</h3>
    <hr />
    <div class="tags">
      <kor-tag *ngFor="let tag of tags?.elements" [label]="tag"></kor-tag>
    </div>
  </div>
</div>

<app-add-to-collection-modal
  [page]="{ pageUid: page?.uid, versionUid: selectedVersion?.uid }"
  *ngIf="addToCollectionModalVisible"
  (close)="addToCollectionModalVisible = false"
></app-add-to-collection-modal>
